export const colors = {
  darkBlue: "#0C4DA2",
  darkBlueOpacity1: "#0C4DA2CC", // 78% opacidad
  darkBlueOpacity2: "#0C4DA266", //40% opacidad
  lightBlue: "#129FDA",
  pink: "#EE357A",
  magenta: "#C00B6C",
  orange: "#F37053",
  yellow: "#FCB040",
  green: "#0CA23F",
  lightGreen: "#E1FFEB",
  lightPink: "#FDE2FF",
  black: "#1E1E1E",
  darkGrey: "#425466",
  grey: "#667892", //"#8F9DAC",
  lightGrey: "#CED4DA",
  background: "#ECF0FB",
  white: "#FFFFFF",
  skeletonGrey1: "#CED4DA",
  skeletonGrey2: "#DEE2E6",
};

export const avatarColors = [
  "#E76144",
  "#E70C74",
  "#CF0072",
  "#F8AC08",
  "#08468F",
  "#0D63AE",
  "#069CD9",
  "#5AC0F0",
];
